import {CareTaskComplementary} from '../../../backend/interfaces/care-task-complementary';
import {CaregiverTaskCompletion} from '../../../enums/caregiver-task-completion';
import {TaskStatus} from '../../shared/badges/task-status';

interface StatusCellProps {
  value: CaregiverTaskCompletion;
  task: CareTaskComplementary;
}

export const StatusCell = ({value, task}: StatusCellProps) => {
  return <TaskStatus task={task} />;
};
